<template>
  <div class="sellersettings">
     <h1> About the Seller</h1>

     <div class="ml-4 text-xs-left" >
       <br /><br />

       <!-- Seller Name -->
       <SellerNameCard></SellerNameCard>

       <!-- Biography -->
       <SellerBioCard></SellerBioCard>
       <!-- Picture -->
       <br />
       <SellerPictureCard></SellerPictureCard>

       <ReturnToDashboard></ReturnToDashboard>
    </div>
</div>

</template>

<script>

import {mapState} from 'vuex'
import SellerBioCard from './sellersettings/SellerBioCard'
import SellerPictureCard from './sellersettings/SellerPictureCard'
import SellerNameCard from './sellersettings/SellerNameCard'
import ReturnToDashboard from './ReturnToDashboard'

export default {
  name: 'SellerSettings',
  components: {
    SellerBioCard, SellerPictureCard, SellerNameCard, ReturnToDashboard
  },
  computed: {
    ...mapState({
    })

  },
  props: {

  },
  data () {
    return {
    }
  },

  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
